module.exports = __webpack_public_path__ + "static/media/agency-bumble.9acd7296.png";